export default __webpack_public_path__ + "static/media/AlFresco.1a3245cc.ttf";